import React from 'react'

function EventCards(props) {
    return (
        <div className='event-card'>
            <img className='event-photo' src={props.event.photo} alt={props.event.title}/>
            <div className='event-content'>
            <h3>{props.event.title}</h3>
            <p>{props.event.content}</p>
            <p>Click <a href={props.event.form}>here</a> to Register NOW!</p>
            </div>
        </div>
    )
}

export default EventCards
